import { ELocalStorage } from '@/types/enum/LocalStorageEnum'
import type { DeviceModel } from '@/types/models/DeviceModel'
import type { EventModel } from '@/types/models/EventModel'
import { getItemFromStorage } from '@/utils/localStorageUtils'
import { computed } from 'vue'
import type { CheckpointModel } from '../models/CheckpointModel'

export type DeviceFiltersType = Partial<DeviceModel> & AdvancedDeviceFilters

export const defaultDeviceFilters: DeviceFiltersType = {}

export type LocalStorageFilter = {
    event: Partial<EventModel>
    checkpoint: Partial<CheckpointModel>
}
const siteId = computed(
    () => getItemFromStorage<LocalStorageFilter>(ELocalStorage.FILTERS)?.event?.id
)

export type AdvancedDeviceFilters = {
    lowSignal?: boolean
    lowBattery?: boolean
}

export const defaultAdvancedDeviceFilters = computed<Partial<DeviceModel>>(() => ({
    site_id: siteId.value ? parseInt(siteId.value.toString()) : undefined
}))
